import { Controller } from "@hotwired/stimulus"
import Navigation from 'a11y-menu'

export default class extends Controller {
  static values = {
    menuId: { type: String, default: 'nav-menu-mobile' },
    click: { type: Boolean, default: true }
  }

  connect() {
    this._nav = new Navigation({
      menuId: this.menuIdValue,
      click: this.clickValue
    })

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        try {
          this._nav.init()
        } catch (e) {
          console.error('Error initializing mobile menu:', e)
        }
      }, { once: true })
    } else {
      try {
        this._nav.init()
      } catch (e) {
        console.error('Error initializing mobile menu:', e)
      }
    }
  }
}
